import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { baseCompList, } from 'rs-ng-base';
import { RsNgButtonLineComponent } from './rs-ng-button-line.component';
@NgModule({
  declarations: [
    RsNgButtonLineComponent
  ],
  imports: [
    CommonModule,

  ],
  exports: [
    RsNgButtonLineComponent
  ],
  entryComponents: [
    ...baseCompList
  ]
})
export class RsNgButtonLineModule { }
